// tanstack
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

// api
import { useGatewaysGetAsyncByidQuery } from '@/api/generated/recalc/endpoints/v1/gateways';

// components
import { useBreadcrumb } from '@/hooks/useBreadcrumb';

import { skipToken } from '@reduxjs/toolkit/query';

export const Route = createFileRoute('/$accountId/_user/gateways/$gatewayId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { gatewayId } = useParams({ strict: false });
  const numericGatewayId = gatewayId ? Number(gatewayId) : undefined;

  const { data: gateway } = useGatewaysGetAsyncByidQuery(
    numericGatewayId != null ? { id: numericGatewayId } : skipToken,
  );

  useBreadcrumb(gateway?.Name ?? '');
  return <Outlet />;
}
